<template>
  <div class="review-history-page">
    <!-- 列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadMore"
    >
    <div v-for="(item, index) in listData" :key="index">
      <div class="review-cell-box">
        <div class="title-box">
          <!-- 标题 -->
          <div v-if="item.status == -2" class="title">单项委托业务撤销</div>
          <div v-else-if="item.status == -3" class="title">单项委托业务撤回</div>
          <div v-else class="title">单项委托审批</div>
          <!-- 状态 -->
          <div v-if="item.status == 1" class="status pass">审批通过</div>
          <div v-else-if="item.status == -1" class="status reject">已驳回</div>
          <div v-else-if="item.status == -2" class="status cancel">已撤销</div>
          <div v-else-if="item.status == -3" class="status cancel">已撤回</div>
        </div>
        <p class="create-time">提审时间：{{ item.createTime }}</p>
        <div class="separator"></div>
        <!-- 内容描述 -->
        <div class="content-box">
          <div v-if="item.status == -2 || item.status == -3" class="title">业务描述</div>
          <div v-else class="title">旅行社单项委托业务描述</div>
          <div class="content">{{ item.cmt }}</div>
        </div>
        <!-- 审核通过/不通过意见 -->
        <div v-if="item.status == 1 || item.status == -1" class="result-box">
          <div class="title">批复意见</div>
          <div class="content">{{ item.logs[0].cmt }}</div>
        </div>
        <!-- 时间 -->
        <div v-if="item.status == -2" class="update-time">撤销时间：{{ item.updateTime }}</div>
        <div v-else-if="item.status == -3" class="update-time">取消时间：{{ item.updateTime }}</div>
        <div v-else class="update-time">审批时间：{{ item.logs[0].createTime }}</div>
      </div>
    </div>
    </van-list>
  </div>
</template>

<script>
    import api from '../../service/modules/travel';

    export default {
        data () {
            return {
                travelId: this.$route.query.travelId,
                loading: false,
                finished: false,
                pagination: { total: 0, currentPage: 0, pageSize: 0 },
                listData: []
            }
        },
        methods: {
            fetchHistoryList () {
                api.getTravelApplyList({
                    travelId: this.travelId,
                    current: parseInt(this.pagination.currentPage) + 1,
                    pageSize: 20,
                    // 只查询 通过/驳回/撤销/取消的类型
                    statusList: [1, -1, -2, -3]
                })
                    .then(res => {
                        if (res.ret === 0) {
                            this.listData = [...this.listData, ...res.data.list];
                            this.pagination = res.data.pagination;
                            this.loading = false
                            if (this.pagination.currentPage >= Math.ceil(this.pagination.total / this.pagination.pageSize)) {
                                this.finished = true;
                            }
                        }
                    })
            },
            loadMore () {
                // loading
                this.fetchHistoryList()
            }
        }
    }
</script>

<style scoped lang="less">
.review-history-page {
  width: 100%;
  min-height: 100%;
  background: #f0f2f5;
  .review-cell-box {
    background-color: #ffffff;
    border-radius: 4px;
    margin: 12px;
    padding-left: 14px;
    padding-right: 14px;
    padding-top: 12px;
    padding-bottom: 18px;
    .title-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: 600;
        color: #1e2226;
      }
      .status {
        font-size: 14px;
        font-weight: 400;
      }
      .pass {
        color: #36B374;
      }
      .reject {
        color: #EF750A;
      }
      .cancel {
        color: #71747A;
      }
    }
    .create-time {
      margin-top: 6px;
      font-size: 12px;
      color: #71747A;
    }
    .separator {
      width: 100%;
      height: 1px;
      background-color: #f1f2f5;
      margin-top: 12px;
      margin-bottom: 12px;
    }
    .content-box {
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #1e2226;
      }
      .content {
        margin-top: 6px;
        font-size: 14px;
        color: #71747A;
      }
    }
    .result-box {
      margin-top: 20px;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #1e2226;
      }
      .content {
        margin-top: 10px;
        font-size: 14px;
        color: #71747A;
      }
    }
    .update-time {
      margin-top: 6px;
      font-size: 14px;
      color: #71747A;
    }
  }
}

</style>
